module.exports = __webpack_public_path__ + "img/Bhavana's image.758b0763.png";